"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const Provider_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/models/Provider"));
const axios_1 = __importDefault(require("axios"));
class ProvidersService {
    constructor() {
        this.data = [];
    }
    async fetchProviders() {
        try {
            const { data } = await axios_1.default.get('/integrations/leaf/providers/list');
            this.data = data.providers.map((provider) => new Provider_1.default({
                id: provider.provider_id,
                name: provider.name,
                logo: provider.logo,
                linked: provider.linked,
                disabled: provider.disabled
            }));
        }
        catch (error) {
            console.error('Error fetching providers:', error.message || error);
        }
    }
}
exports.default = ProvidersService;
